import React from 'react';

interface IMenuContext {
    menuCollapsed: boolean,
    setMenuCollapsed: (collapsed: boolean) => void,
}

const Menu = React.createContext<IMenuContext>({ menuCollapsed: true, setMenuCollapsed: (collapsed) => console.debug(collapsed) });


export default Menu;